import { h, Component } from 'preact';
import Cookies from 'universal-cookie';
import WPN from 'q-push-notifications';
import showCustomPopup from 'q-push-notifications/lib/prototypes/optional/showGenericPreRequestModal';
import { ABRAND_COOKIE_KEY, ALL_INDIA } from '../../helpers/constants';
import { getCurrentCity } from '../../helpers';
import axios from 'axios';
import './index.scss';


WPN.prototype.showCustomPopup = showCustomPopup;
const cookies = new Cookies();

class NotificationPopup extends Component {
	constructor(props) {
		super(props);
		this.probability = props.probability || 100;
		this.state = {
			qcash : 100
		};
	}

	componentDidMount() {
		const abRand = cookies.get(ABRAND_COOKIE_KEY) || Math.random() * 100;
		const cityName = getCurrentCity();
		const context = 'ChromeNotifications';
		axios.get(`https://www.quikr.com/ssr-api/core/common/getQcash/${context}`)
			.then((response)=>{
				let result = response.data;
				if (result){
					this.setState({
						qcash : result
					});
				}
			}).catch(()=>{
			});
		if (this.probability === 100 || Number(abRand) <= this.probability) {
			const initiateNotificationPopup = () => {
				if (this.props.withTimeout) {
					setTimeout(this.initiate, this.props.withTimeout * 1000);
				} else {
					this.initiate();
				}
			};
			if (cityName === ALL_INDIA && this.props.geolocationEnabled) {
				let counter = 0;
				const checkGeoLocationStatus = () => {
					if (typeof navigator.permissions !== "undefined"){
						navigator.permissions.query({ name: 'geolocation' }).then((geoPermission) => {
							if (geoPermission.state !== 'prompt') {
								initiateNotificationPopup();
							} else if (counter <= 10) {
								counter += 1;
								setTimeout(checkGeoLocationStatus, 2000);
							}
						});
					} else {
						initiateNotificationPopup();
					}
				};
				checkGeoLocationStatus();
			} else {
				initiateNotificationPopup();
			}
		}
	}

	initiate = () => {
		const webPush = new WPN({
			context: this.props.context,
			pwa: true,
			vertical: this.props.vertical,
			withTimeout: this.props.withTimeout
		});
		webPush.initialize().then((subscription) => {
			const pushCookie = cookies.get('pushSub');
			let promise;
			if (subscription) {
				if (!pushCookie) {
					cookies.set('pushSub', 'true', { path: '/', domain: '.quikr.com', maxAge: 1 * 24 * 60 * 60 });
				}
			} else {
				if (this.props.customPopup) {
					promise = webPush.showCustomPopup({
						classes: {
							description: 'notif-text'
						},
						description: this.props.customText,
						qcash: this.state.qcash
					});
				} else {
					promise = webPush.requestPermission();
				}
				promise.then(() => {
					const isLoggedIn = this.props.userInfo && this.props.userInfo.loggedIn;
					if (isLoggedIn){
						const params = {
							user: this.props.userInfo,
							context: 'ChromeNotifications'
						};
						axios.post('https://www.quikr.com/ssr-api/core/common/updateqcash',params)
							.then(response => {
								let result = response.data;
								if (!result.isSuccess){
									//log this error in grey log from failed payment
								}
							})
							.catch((error)=>{
								//log this error in grey log from failed payment
							});
					}
					if (!pushCookie) {
						cookies.set('pushSub', 'false', { path: '/', domain: '.quikr.com', maxAge: 1 * 24 * 60 * 60 });
					}
				}).catch((err) => {
					console.error(err.message);
				});
			}
		});
	}

	render() {
		return null;
	}
}

NotificationPopup.defaultProps = {
	geolocationEnabled: true
};

export default NotificationPopup;


// WEBPACK FOOTER //
// ../q-components/components/notificationPopup/index.js